export const generatePresignedUrlMutation = `
mutation getPresignedPost($fileNames: [String!]!) {
    generateUploadUrls(inputData: {fileNames: $fileNames}) {
        uploadUrls
    }
}
`;
